import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import styled from "@emotion/styled";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";
import Autocomplete from "Components/UI/Form/Autocomplete";

export default function ClientsComboBox({
  label,
  clients,
  selectedID,
  disabled,
  onChange,
}) {
  const navigate = useNavigate();
  return (
    <Autocomplete
      key={selectedID}
      value={
        clients
          ? clients.find((client) => {
              return client.Id === selectedID;
            })
          : null
      }
      disabled={disabled}
      options={clients ? clients : []}
      getOptionLabel={(client) => client?.Name + "-" + client?.Id}
      isOptionEqualToValue={(option, value) => {
        return option.Id === value?.Id || value == null;
      }}
      onChange={(event, newValue) => {
        onChange(newValue == null ? null : newValue.Id);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  display: selectedID != null ? "flex" : "none",
                }}
              >
                <IconButton
                  onClick={() => navigate(`/clients/${selectedID}`)}
                  edge="end"
                >
                  {<LinkIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          label={label ? label : ""}
        />
      )}
    />
  );
}
